module.exports = __webpack_public_path__ + "img/23_38.77cc9f67.png";